/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { SetGlobalStyle } from "@nordcloud/gnui";

import { App } from "./App";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import {
  auth0Client,
  Auth0ProviderWithHistory,
  AuthWall,
} from "./services/Auth";
import { ApolloProvider } from "./services/Auth/apollo";

ReactDOM.render(
  <Router>
    <Auth0ProviderWithHistory client={auth0Client}>
      <AuthWall>
        <SetGlobalStyle />
        <ApolloProvider>
          <App />
        </ApolloProvider>
      </AuthWall>
    </Auth0ProviderWithHistory>
  </Router>,
  document.getElementById("root")
);
